/* BraccoTCG - Vendi le tue carte (ritiro). Vedi sections/ritiro-carte.liquid */
(function () {
  var NUMBERED = /^\/\d+$/;
  var PLATE = /^Printing Plate /i;
  // Pezzi unici: ne esiste una copia sola. Se ce l'abbiamo gia' in magazzino non si puo' proporre.
  function isUniqueTitle(t) { return t === '/1' || PLATE.test(t); }
  var PLATE_CODE = { ciano: 'PPC', magenta: 'PPM', gialla: 'PPG', nera: 'PPN' };
  var PLATE_ORDER = ['ciano', 'magenta', 'gialla', 'nera'];
  // Nome della versione per le carte a variante unica ("Default Title"), dai tag del prodotto.
  var TYPE_RULES = [
    [function (p) { return /hourglass/i.test(p.title); }, 'Promo Hourglass'],
    [function (p, t) { return t.promo; }, 'Promo a colori'],
    [function (p, t) { return t.godpack; }, 'Concept God Pack'],
    [function (p, t) { return t.cel && /^\s*C\d+\s*b\b/i.test(p.title); }, 'Cel Card acetato'],
    [function (p, t) { return t.cel; }, 'Cel Card sfondo'],
    [function (p, t) { return t.milestone; }, 'Milestone Card'],
    [function (p, t) { return t.popup; }, 'Pop-up Card'],
    [function (p, t) { return t.contract; }, 'Contract'],
    [function (p) { return /ceramic/i.test(p.title); }, 'Ceramic Card'],
    [function (p) { return /fiche/i.test(p.title); }, 'Fiche Card'],
    [function (p, t) { return t.landscape; }, 'Landscape'],
    [function (p, t) { return t.masterpiece; }, 'Masterpiece'],
    [function (p, t) { return t.safari; }, 'Safari'],
    [function (p, t) { return t.special; }, 'Special']
  ];
  function typeName(p) {
    var t = {};
    (p.tags || []).forEach(function (x) { t[String(x).toLowerCase().replace(/[^a-z]/g, '')] = true; });
    for (var i = 0; i < TYPE_RULES.length; i++) { if (TYPE_RULES[i][0](p, t)) return TYPE_RULES[i][1]; }
    return 'Standard';
  }
  // Nomi del tipo di una speciale da cercare in type_rules del PDC (Cel, Promo, Lenticular...)
  function typeCandidates(p) {
    var n = typeName(p), out = [n];
    if (/^Cel Card/.test(n)) out.push('Cel');
    if (/^Promo/.test(n)) out.push('Promo');
    if (n === 'Concept God Pack') out.push('Godpack');
    return out.concat(p.tags || []);
  }
  var CACHE_KEY = 'braccotcg-ritiro-cache-v2';
  var CACHE_TTL = 15 * 60 * 1000; // 15 minuti

  function init(root) {
    if (root.dataset.rcInit) return;
    if (!root.querySelector('script[data-rc-config]') || !root.querySelector('form.rc-form')) return;
    root.dataset.rcInit = '1';

    var cfg = JSON.parse(root.querySelector('script[data-rc-config]').textContent);
    // Prezzi dal PDC (metafield braccotcg.ritiro_prezzi). In una funzione perche' prima dell'invio si rileggono dal negozio.
    function upperKeys(o) { var r = {}; Object.keys(o || {}).forEach(function (k) { r[k.toUpperCase()] = o[k]; }); return r; }
    function normType(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    var P, RULES, TYPE_RULES_P, SKU_FIXED, SKU_NEXT, DEF_PCT, CREDIT_UP_PCT, CREDIT_UP, MIN_TOTAL, BONUS, SOLD_OUT_BONUS;
    var LOT_CUT, LOT_OUT, LOT_MAX, LOT_MIN, LOT_VERSIONS, LOT_FIXED, NUMBERED_SETS, COLLAPSE, SPOT_ID, SPOT_SKU, SPOT_ORDER, TAG;
    function applyPrices(prices) {
      P = prices || {};
      RULES = upperKeys(P.rules);
      // % per tipo delle carte speciali senza versione nello SKU (es. CUP-C01A): { "CUP": { "Cel": 40 } }
      TYPE_RULES_P = {};
      Object.keys(P.type_rules || {}).forEach(function (s) {
        var m = {};
        Object.keys(P.type_rules[s] || {}).forEach(function (t) { m[normType(t)] = parseFloat(P.type_rules[s][t]); });
        TYPE_RULES_P[s.toUpperCase()] = m;
      });
      SKU_FIXED = {};
      Object.keys(P.sku || {}).forEach(function (k) { SKU_FIXED[k.toUpperCase()] = parseFloat(P.sku[k]); });
      // Carte che scendono con i prezzi dinamici: si ritirano gia' al prezzo futuro (come il PDC)
      SKU_NEXT = {};
      Object.keys(P.sku_previsti || {}).forEach(function (k) { SKU_NEXT[k.toUpperCase()] = parseFloat(P.sku_previsti[k]); });
      // Prezzo base = bonifico (% del prezzo di vendita). Il codice sconto vale il bonifico + credit_bonus%.
      DEF_PCT = isFinite(parseFloat(P.default_percent)) ? parseFloat(P.default_percent) : parseFloat(cfg.cashPct);
      CREDIT_UP_PCT = isFinite(parseFloat(P.credit_bonus)) ? parseFloat(P.credit_bonus) : parseFloat(cfg.creditBonus);
      CREDIT_UP = (CREDIT_UP_PCT || 0) / 100;
      MIN_TOTAL = isFinite(parseFloat(P.min_total)) ? parseFloat(P.min_total) : (parseFloat(cfg.minTotal) || 0);
      BONUS = Math.max(0, parseFloat(P.spotlight_bonus) || 0);
      SOLD_OUT_BONUS = isFinite(parseFloat(P.sold_out_bonus)) ? Math.max(0, parseFloat(P.sold_out_bonus)) : null;
      // Ritiro a lotto: prezzo fisso a copia per versione, con uno sconto perche' le carte vanno smistate da noi.
      LOT_CUT = (isFinite(parseFloat(P.lot_discount)) ? parseFloat(P.lot_discount) : (parseFloat(cfg.lotDiscount) || 0)) / 100;
      LOT_OUT = parseFloat(P.lot_outlier) > 1 ? parseFloat(P.lot_outlier) : 2;
      LOT_MAX = parseFloat(P.lot_max_price) > 0 ? parseFloat(P.lot_max_price) : 2;   // prezzo di vendita tipico massimo della versione
      LOT_MIN = parseInt(P.lot_min_cards, 10) > 0 ? parseInt(P.lot_min_cards, 10) : 20; // carte minime nella versione
      LOT_VERSIONS = (P.lot_versions || []).map(function (s) { return String(s).toUpperCase(); }); // es. ["DIN-REG","DIN-TRC"]: se presente decide lui
      LOT_FIXED = {};
      Object.keys(P.lot_prices || {}).forEach(function (k) { LOT_FIXED[k.toUpperCase()] = parseFloat(P.lot_prices[k]); });
      NUMBERED_SETS = (P.numbered_sets || cfg.numberedSets || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
      COLLAPSE = (P.collapse_variants || cfg.collapseVariants || []).map(function (s) {
        s = String(s).trim();
        if (!s) return null;
        try { return new RegExp(s.charAt(0) === '^' ? s : '^' + s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'); } catch (e) { return null; }
      }).filter(Boolean);
      // Le carte in evidenza vengono solo segnalate: il motivo (esaurita, va a ruba...) resta interno e decide solo il bonus.
      SPOT_ID = {}; SPOT_SKU = {}; SPOT_ORDER = {};
      (P.spotlight || []).forEach(function (s, i) {
        var why = String(s.reason || 'si');
        if (s.id) { SPOT_ID[String(s.id)] = why; SPOT_ORDER[String(s.id)] = i; }
        if (s.sku) { SPOT_SKU[String(s.sku).toUpperCase()] = why; SPOT_ORDER['sku:' + String(s.sku).toUpperCase()] = i; }
      });
      TAG = BONUS > 0 ? '+' + BONUS + '% sul ritiro' : 'Stiamo cercando';
    }
    applyPrices(cfg.prices);
    var MIN_VER = 3;
    var STORE_KEY = 'braccotcg-ritiro-v2';
    var PAGE = 36;
    var EAGER = 8;
    var excludeTypes = (cfg.excludeTypes || []).map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var excludeWords = (cfg.excludeWords || []).map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var HANDLES = cfg.collections.map(function (c) { return c.handle; });
    var TITLES = {};
    cfg.collections.forEach(function (c) { TITLES[c.handle] = c.title; });
    var DEFAULT_SET = HANDLES.indexOf(cfg.defaultSet) > -1 ? cfg.defaultSet : (HANDLES[0] || 'all');

    var raw = {};          // handle -> prodotti (forma ridotta)
    var loaded = {};       // handle -> true quando il set e' disponibile
    var allLoaded = false;
    var cards = [];
    var byVariant = {};
    var spots = [];
    var shown = PAGE;
    var urlSet = new URLSearchParams(location.search).get('set');
    var filterSet = urlSet && (urlSet === 'all' || HANDLES.indexOf(urlSet) > -1) ? urlSet : DEFAULT_SET;
    var filterVer = '';
    var query = '';
    var pay = 'cash';
    var payout = 'cash'; // come vuole essere pagato nella proposta: cash | credit | mix
    var basket = load();
    var form = root.querySelector('form.rc-form');
    try { localStorage.removeItem('braccotcg-ritiro-v1'); } catch (e) {}

    function money(n) { return (Math.round(n * 100) / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }); }
    function floor2(n) { return Math.floor(n * 100 + 1e-6) / 100; }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function load() { try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; } }
    function save() { try { localStorage.setItem(STORE_KEY, JSON.stringify(basket)); } catch (e) {} }
    function sizedImg(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function $(sel) { return root.querySelector(sel); }
    function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
    function shortName(title) { return String(title).split(' by ')[0].replace(/\s*\|\s*/, ' ').trim(); }

    // ---------- prezzi di ritiro (dal PDC) ----------
    function skuParts(sku) {
      var parts = String(sku || '').toUpperCase().split('-');
      return { set: parts[0] || '', ver: parts.slice(2).join('-') };
    }
    // types: nomi del tipo della carta speciale (variante unica), per type_rules; contano solo senza versione nello SKU
    function typeRule(set, types) {
      var m = TYPE_RULES_P[set];
      if (!m || !types) return null;
      for (var i = 0; i < types.length; i++) { var k = normType(types[i]); if (k && isFinite(m[k])) return m[k]; }
      return null;
    }
    function ruleFor(sku, types) {
      var p = skuParts(sku);
      if (p.set && p.ver && RULES[p.set + '-' + p.ver] != null) return parseFloat(RULES[p.set + '-' + p.ver]);
      if (p.set && !p.ver) { var t = typeRule(p.set, types); if (t != null) return t; }
      if (p.set && RULES[p.set] != null) return parseFloat(RULES[p.set]);
      return DEF_PCT;
    }
    // prezzo deciso dal PDC per la singola carta (fisso a mano o previsto dai prezzi dinamici): niente bonus in evidenza
    function hasFixed(sku) { var s = String(sku || '').toUpperCase(); return !!s && (isFinite(SKU_FIXED[s]) || isFinite(SKU_NEXT[s])); }
    // prezzo in bonifico
    function cashFor(sku, price, types) {
      var s = String(sku || '').toUpperCase();
      if (s && isFinite(SKU_FIXED[s])) return floor2(SKU_FIXED[s]);
      if (s && isFinite(SKU_NEXT[s])) return floor2(SKU_NEXT[s]);
      return floor2(price * ruleFor(sku, types) / 100);
    }
    // bonus delle carte in evidenza: le esaurite hanno il loro (sold_out_bonus), le altre spotlight_bonus
    function spotWhy(v) { return SPOT_ID[v.id] || (v.sku && SPOT_SKU[String(v.sku).toUpperCase()]) || ''; }
    function spotBonus(v) { var w = spotWhy(v); return !w ? 0 : (w === 'esaurita' && SOLD_OUT_BONUS != null ? SOLD_OUT_BONUS : BONUS); }
    // prezzo in codice sconto = bonifico + CREDIT_UP
    function creditOf(cash) { return floor2(cash * (1 + CREDIT_UP)); }
    function unitOf(b) { return pay === 'cash' ? b.cash : b.credit; }
    function isSpot(v) { return !!(SPOT_ID[v.id] || (v.sku && SPOT_SKU[String(v.sku).toUpperCase()])); }

    // ---------- numeri carta ----------
    function sortKey(title) { var m = String(title).match(/^\s*([A-Za-z]*)\s*(\d+)/); return m ? [m[1].toUpperCase(), parseInt(m[2], 10)] : ['ZZZ', 99999]; }
    function cmpKey(a, b) { return a[0] === b[0] ? a[1] - b[1] : (a[0] < b[0] ? -1 : 1); }

    // ---------- dati: rete + cache ----------
    function slim(p) {
      return {
        title: p.title, handle: p.handle, type: p.product_type || '', tags: p.tags || [], vendor: p.vendor || '',
        img: (p.images && p.images[0] && p.images[0].src) || '',
        variants: (p.variants || []).map(function (v) { return { id: String(v.id), title: v.title, sku: v.sku || '', price: v.price, avail: !!v.available, img: (v.featured_image && v.featured_image.src) || '' }; })
      };
    }
    function fetchRaw(handle, fresh) {
      var out = [];
      function page(n) {
        var pre = !fresh && n === 1 && window.__rcPre && window.__rcPre[handle];
        if (pre) delete window.__rcPre[handle];
        var req = pre || fetch('/collections/' + handle + '/products.json?limit=250&page=' + n + (fresh ? '&_rc=' + Date.now() : ''), { credentials: 'same-origin', cache: fresh ? 'no-store' : 'default' })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; });
        return req.then(function (data) {
          var prods = (data && data.products) || [];
          out = out.concat(prods.map(slim));
          if (prods.length === 250 && n < 10) return page(n + 1);
          return out;
        });
      }
      return page(1);
    }
    function readCache() { try { var c = JSON.parse(localStorage.getItem(CACHE_KEY)); return c && c.data ? c : null; } catch (e) { return null; } }
    function writeCache(data) { try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: data })); } catch (e) {} }

    // ---------- costruzione carte ----------
    function isSingle(p) {
      if (excludeTypes.indexOf(String(p.type).toLowerCase()) > -1) return false;
      var t = String(p.title).toLowerCase();
      for (var i = 0; i < excludeWords.length; i++) { if (t.indexOf(excludeWords[i]) > -1) return false; }
      var tags = (p.tags || []).map(function (x) { return String(x).toLowerCase(); });
      if (tags.indexOf('bundle') > -1 || tags.indexOf('starter set') > -1) return false;
      return true;
    }
    // Prodotti come i Frammenti (osso, dente, guscio): tutte le varianti diventano una sola voce col nome del pezzo
    // ("Frammento d'osso 2" -> "Frammento d'osso").
    function collapse(card) {
      if (card.variants.length < 2 || !COLLAPSE.length) return;
      var all = card.variants.every(function (v) { return COLLAPSE.some(function (re) { return re.test(v.title); }); });
      if (!all) return;
      var first = card.variants[0];
      first.title = first.title.replace(/\s+\d+$/, '');
      first.kind = 'type';
      first.sample = false;
      first.img = card.img || first.img;
      card.variants = [first];
    }
    function buildSet(col, list) {
      return list.filter(isSingle).map(function (p) {
        var card = {
          key: col.handle + ':' + p.handle, handle: p.handle, title: p.title, num: sortKey(p.title),
          setHandle: col.handle, setTitle: col.title, img: p.img,
          search: (p.title + ' ' + p.handle + ' ' + p.vendor).toLowerCase(), variants: []
        };
        card.variants = p.variants.map(function (v) {
          var price = parseFloat(v.price) || 0;
          var single = v.title === 'Default Title';
          var cash = cashFor(v.sku, price, single ? typeCandidates(p) : null);
          var unique = isUniqueTitle(v.title);
          return { id: v.id, title: single ? typeName(p) : v.title, kind: single ? 'type' : '', sku: v.sku, price: price, base: cash, cash: cash, credit: creditOf(cash), img: v.img || p.img, sample: !v.img && p.variants.length > 1, unique: unique, owned: unique && v.avail };
        }).filter(function (v) { return v.price > 0 && v.cash > 0; });
        collapse(card);
        return card;
      }).filter(function (c) { return c.variants.length; });
    }
    // Versioni che il cliente puo' avere anche se noi non le abbiamo mai caricate su Shopify
    // (prezzo = mediana della stessa versione nel set):
    // - set a numerate (Cuphead): tutte le numerazioni su ogni carta del set principale; la /150 Missprint solo sulle Rare;
    // - set con le Printing Plate (Dinosaurs): i quattro colori su ogni carta Regular e Timeshifted.
    var MISPRINT = '/150 Missprint';
    var PLATE_TITLES = PLATE_ORDER.map(function (c) { return 'Printing Plate ' + c.charAt(0).toUpperCase() + c.slice(1); });
    function median(a) { a = a.slice().sort(function (x, y) { return x - y; }); return a[Math.floor(a.length / 2)]; }
    function baseSku(c) {
      var base = '';
      c.variants.some(function (v) { var p = String(v.sku || '').split('-'); if (p.length >= 3) { base = p[0] + '-' + p[1]; return true; } return false; });
      return base;
    }
    function addVirtual(c, t, sku, price) {
      if (!(price > 0) || c.variants.some(function (v) { return v.title === t; })) return;
      var cash = cashFor(sku, price);
      if (cash <= 0) return;
      c.variants.push({ id: 'nuova:' + c.handle + ':' + t, title: t, kind: '', sku: sku, price: price, base: cash, cash: cash, credit: creditOf(cash), img: c.img, sample: true, virtual: true, unique: isUniqueTitle(t), owned: false });
    }
    function variantRank(t) {
      if (PLATE.test(t)) return 4 + PLATE_ORDER.indexOf(t.replace(PLATE, '').toLowerCase()) / 10;
      if (t === MISPRINT) return 3;
      if (NUMBERED.test(t)) return 2 - parseInt(t.slice(1), 10) / 100000;
      return 0;
    }
    function fillVirtual(list, numbered) {
      var prices = {};
      list.forEach(function (c) { c.variants.forEach(function (v) {
        if (NUMBERED.test(v.title) || PLATE.test(v.title) || v.title === MISPRINT) (prices[v.title] = prices[v.title] || []).push(v.price);
      }); });
      if (numbered) {
        var titles = Object.keys(prices).filter(function (t) { return NUMBERED.test(t) && prices[t].length >= 2; });
        list.forEach(function (c) {
          if (c.num[0] !== '') return;
          var base = baseSku(c);
          titles.forEach(function (t) { addVirtual(c, t, base ? base + '-N' + t.slice(1) : '', median(prices[t])); });
          if (prices[MISPRINT] && c.variants.some(function (v) { return v.title === 'Rara'; })) addVirtual(c, MISPRINT, base ? base + '-N150M' : '', median(prices[MISPRINT]));
        });
      }
      var allPlates = [];
      PLATE_TITLES.forEach(function (t) { allPlates = allPlates.concat(prices[t] || []); });
      if (allPlates.length) {
        list.forEach(function (c) {
          if (!c.variants.some(function (v) { return v.title === 'Regular' || v.title === 'Timeshifted'; })) return;
          var base = baseSku(c);
          PLATE_TITLES.forEach(function (t) {
            var code = PLATE_CODE[t.replace(PLATE, '').toLowerCase()];
            addVirtual(c, t, base ? base + '-' + code : '', median(prices[t] || allPlates));
          });
        });
      }
      list.forEach(function (c) {
        c.variants.forEach(function (v, i) { v._i = i; });
        c.variants.sort(function (a, b) { return (variantRank(a.title) - variantRank(b.title)) || (a._i - b._i); });
      });
    }
    function setIndex(h) { var i = HANDLES.indexOf(h); return i < 0 ? 99 : i; }

    // ---------- ritiro a lotto ----------
    // Per ogni versione del set: prezzo a copia = mediana del bonifico delle carte, meno LOT_CUT.
    // Le carte che valgono piu' di LOT_OUT volte la mediana restano fuori dal lotto (vanno aggiunte singolarmente).
    function lotsFor(h) {
      var groups = {}, order = [];
      cards.forEach(function (c) {
        if (c.setHandle !== h) return;
        c.variants.forEach(function (v) {
          if (v.virtual || v.unique || NUMBERED.test(v.title) || v.title === MISPRINT) return;
          if (!groups[v.title]) { groups[v.title] = []; order.push(v.title); }
          groups[v.title].push({ c: c, v: v });
        });
      });
      return order.filter(function (t) { return groups[t].length >= MIN_VER; }).map(function (t) {
        var items = groups[t];
        var sp0 = skuParts(items[0].v.sku);
        var key0 = sp0.set && sp0.ver ? sp0.set + '-' + sp0.ver : '';
        if (LOT_VERSIONS.length) {
          if (LOT_VERSIONS.indexOf(key0) < 0) return null;
        } else {
          var pr = items.map(function (x) { return x.v.price; }).sort(function (a, b) { return a - b; });
          if (items.length < LOT_MIN || pr[Math.floor(pr.length / 2)] > LOT_MAX) return null;
        }
        var bases = items.map(function (x) { return x.v.base; }).sort(function (a, b) { return a - b; });
        var med = bases[Math.floor(bases.length / 2)];
        var prices = items.map(function (x) { return x.v.price; }).sort(function (a, b) { return a - b; });
        var out = items.filter(function (x) { return x.v.base > med * LOT_OUT; });
        var sp = skuParts(items[0].v.sku);
        var key = sp.set && sp.ver ? sp.set + '-' + sp.ver : '';
        var cash = key && isFinite(LOT_FIXED[key]) ? floor2(LOT_FIXED[key]) : floor2(med * (1 - LOT_CUT));
        return {
          id: 'lotto:' + h + ':' + t, set: h, setTitle: TITLES[h] || h, title: t, count: items.length - out.length,
          cash: cash, credit: creditOf(cash), price: prices[Math.floor(prices.length / 2)],
          sku: sp.set ? sp.set + '-LOTTO-' + (sp.ver || 'X') : '', out: out
        };
      }).filter(function (l) { return l && l.cash > 0; });
    }
    function findLot(id) {
      var m = String(id).match(/^lotto:([^:]+):(.*)$/);
      if (!m) return null;
      var hit = null;
      lotsFor(m[1]).some(function (l) { if (l.id === id) { hit = l; return true; } return false; });
      return hit;
    }

    // ---------- prezzi cambiati nella proposta ----------
    // id -> { name, cash, credit (prima), newCash, newCredit (dopo, 0 = non piu' ritirabile) }
    var priceChanges = {};
    function noteChange(id, b, cash, credit) {
      if (b.cash == null || (Math.abs(b.cash - cash) < 0.005 && Math.abs(b.credit - credit) < 0.005)) return;
      var c = priceChanges[id] || { name: b.product + (b.variant ? ' [' + b.variant + ']' : ''), cash: b.cash, credit: b.credit };
      c.newCash = cash; c.newCredit = credit;
      if (Math.abs(c.cash - cash) < 0.005 && Math.abs(c.credit - credit) < 0.005) delete priceChanges[id];
      else priceChanges[id] = c;
    }
    function changesBox() {
      var box = root.querySelector('[data-rc-changes]');
      if (box) return box;
      box = document.createElement('div');
      box.className = 'rc-err rc-changes';
      box.setAttribute('data-rc-changes', '');
      box.setAttribute('role', 'alert');
      box.hidden = true;
      var sub = form.querySelector('[data-rc-submit]');
      sub.parentNode.insertBefore(box, sub);
      return box;
    }
    function showChanges() {
      var ids = Object.keys(priceChanges), box = changesBox();
      if (!ids.length) { box.hidden = true; box.innerHTML = ''; return; }
      var useCredit = payout === 'credit';
      var rows = ids.map(function (id) {
        var c = priceChanges[id];
        var before = useCredit ? c.credit : c.cash, after = useCredit ? c.newCredit : c.newCash;
        return '<li>' + esc(c.name) + ': ' + (after > 0 ? money(before) + ' → <strong>' + money(after) + '</strong>' : 'non la ritiriamo più, l\'abbiamo tolta') + '</li>';
      }).join('');
      box.innerHTML = '<strong>Abbiamo aggiornato i prezzi della tua proposta.</strong> Il ritiro segue i nostri prezzi di vendita, che cambiano nel tempo: ' +
        (ids.length === 1 ? 'questa carta ora vale' : 'queste carte ora valgono') + ' così (a copia, ' + (useCredit ? 'in codice sconto' : 'in bonifico') + '):' +
        '<ul style="margin:.5em 0 .5em 1.2em;padding:0">' + rows + '</ul>Il totale qui sopra è già aggiornato. Se ti va bene, premi di nuovo «Invia la proposta».';
      box.hidden = false;
    }
    function clearChanges() { priceChanges = {}; showChanges(); }

    function rebuild() {
      var sel = {};
      cards.forEach(function (c) { if (c._sel) sel[c.key] = c._sel; });
      cards = []; byVariant = {}; spots = [];
      var seen = {};
      cfg.collections.forEach(function (col) {
        if (!raw[col.handle]) return;
        var list = buildSet(col, raw[col.handle]).filter(function (c) { if (seen[c.handle]) return false; seen[c.handle] = 1; return true; });
        fillVirtual(list, NUMBERED_SETS.indexOf(col.handle) > -1);
        // i pezzi unici che abbiamo gia' in magazzino non si possono proporre
        list.forEach(function (c) { c.variants = c.variants.filter(function (v) { return !v.owned; }); });
        cards = cards.concat(list.filter(function (c) { return c.variants.length; }));
      });
      cards.sort(function (a, b) { return (setIndex(a.setHandle) - setIndex(b.setHandle)) || cmpKey(a.num, b.num) || a.title.localeCompare(b.title); });
      cards.forEach(function (c) {
        if (sel[c.key]) c._sel = sel[c.key];
        c.variants.forEach(function (v) {
          byVariant[v.id] = { card: c, v: v };
          v.spot = isSpot(v);
          if (v.spot) {
            var sb = spotBonus(v);
            if (sb > 0 && !hasFixed(v.sku)) { v.cash = floor2(v.base * (1 + sb / 100)); v.credit = creditOf(v.cash); }
            spots.push({ card: c, v: v, order: SPOT_ORDER[v.id] != null ? SPOT_ORDER[v.id] : SPOT_ORDER['sku:' + String(v.sku).toUpperCase()] });
          }
        });
      });
      spots.sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
      var changesBefore = Object.keys(priceChanges).length;
      Object.keys(basket).forEach(function (id) {
        var b = basket[id];
        if (b.lot) {
          if (!loaded[b.setHandle]) return;
          var l = findLot(id);
          if (!l) { delete basket[id]; return; }
          noteChange(id, b, l.cash, l.credit);
          b.price = l.price; b.cash = l.cash; b.credit = l.credit; b.sku = l.sku;
          return;
        }
        var hit = byVariant[id];
        if (!hit) { if (allLoaded) { noteChange(id, b, 0, 0); delete basket[id]; } return; }
        noteChange(id, b, hit.v.cash, hit.v.credit);
        b.price = hit.v.price; b.cash = hit.v.cash; b.credit = hit.v.credit; b.img = hit.v.img; b.setHandle = hit.card.setHandle; b.virtual = !!hit.v.virtual; b.variant = hit.v.title; b.unique = !!hit.v.unique; if (b.unique) b.qty = 1;
      });
      if (Object.keys(priceChanges).length) save();
      if (Object.keys(priceChanges).length > changesBefore) { showChanges(); toast('Alcuni prezzi della tua proposta sono cambiati: controlla il riepilogo'); }
      if (allLoaded) {
        save();
        root.querySelectorAll('[data-set]').forEach(function (b) {
          if (b.dataset.set !== 'all' && !cards.some(function (c) { return c.setHandle === b.dataset.set; })) b.hidden = true;
        });
        if (filterSet !== 'all' && !cards.some(function (c) { return c.setHandle === filterSet; })) selectSet('all', true);
      }
      fillVerFilter();
      render();
    }
    var rebuildQueued = false;
    function queueRebuild() { if (rebuildQueued) return; rebuildQueued = true; setTimeout(function () { rebuildQueued = false; rebuild(); }, 0); }

    function start() {
      var cache = readCache();
      var fresh = cache && Date.now() - cache.t < CACHE_TTL;
      var wasComplete = false;
      if (cache) {
        raw = cache.data;
        HANDLES.forEach(function (h) { if (raw[h]) loaded[h] = true; });
        allLoaded = wasComplete = HANDLES.every(function (h) { return loaded[h]; });
        rebuild();
        if (fresh && allLoaded) return;
      }
      // prima il set aperto, poi gli altri in sottofondo
      var order = HANDLES.slice().sort(function (a, b) { return (b === filterSet) - (a === filterSet); });
      var next = {};
      Promise.all(order.map(function (h) {
        return fetchRaw(h).then(function (list) {
          next[h] = list;
          if (!loaded[h]) { raw[h] = list; loaded[h] = true; queueRebuild(); }
        });
      })).then(function () {
        writeCache(next);
        var changed = !cache || JSON.stringify(next) !== JSON.stringify(cache.data);
        raw = next; HANDLES.forEach(function (h) { loaded[h] = true; }); allLoaded = true;
        if (changed || !wasComplete) rebuild();
      }).catch(function (err) {
        if (window.console) console.error(err);
        if (!cards.length) $('[data-rc-status]').textContent = 'Non riesco a caricare le carte. Ricarica la pagina tra qualche secondo.';
      });
    }

    // ---------- griglia ----------
    // nel filtro: le versioni presenti su almeno `min` carte, e sempre i tipi delle carte speciali (Landscape, Cel Card, Contract...)
    function versionsOf(list, min) {
      var count = {}, type = {}, out = [];
      list.forEach(function (c) { c.variants.forEach(function (v) {
        if (count[v.title] == null) { count[v.title] = 0; out.push(v.title); }
        count[v.title]++;
        if (v.kind === 'type') type[v.title] = true;
      }); });
      out.sort(function (a, b) { return (type[a] ? 1 : 0) - (type[b] ? 1 : 0) || (variantRank(a) - variantRank(b)); });
      return out.filter(function (t) { return type[t] || count[t] >= (min || 1); }).map(function (t) { return { title: t, count: count[t] }; });
    }
    function fillVerFilter() {
      var list = filterSet === 'all' ? cards : cards.filter(function (c) { return c.setHandle === filterSet; });
      var sel = $('[data-rc-verfilter]');
      var vers = versionsOf(list, MIN_VER);
      if (vers.length && vers.every(function (v) { return v.title !== filterVer; })) filterVer = '';
      sel.innerHTML = '<option value="">Tutte le versioni</option>' + vers.map(function (v) {
        return '<option value="' + esc(v.title) + '"' + (v.title === filterVer ? ' selected' : '') + '>' + esc(v.title) + ' (' + v.count + ')</option>';
      }).join('');
    }
    function filtered() {
      var q = query.trim().toLowerCase();
      return cards.filter(function (c) {
        if (filterSet !== 'all' && c.setHandle !== filterSet) return false;
        if (filterVer && !c.variants.some(function (v) { return v.title === filterVer; })) return false;
        if (q && c.search.indexOf(q) === -1) return false;
        return true;
      });
    }
    function selectedVariant(c) {
      var id = c._sel;
      if (!id && filterVer) { var fv = c.variants.find(function (v) { return v.title === filterVer; }); if (fv) id = fv.id; }
      if (!id) { var sv = c.variants.find(function (v) { return v.spot; }); if (sv) id = sv.id; }
      return c.variants.find(function (x) { return x.id === id; }) || c.variants[0];
    }

    function tagHTML(v) {
      if (!v.spot) return '';
      return '<span class="rc-ribbon' + (BONUS > 0 ? ' is-bonus' : '') + '">' + esc(TAG) + '</span>';
    }
    function priceHTML(v) {
      var alt = CREDIT_UP > 0 ? (pay === 'cash'
        ? '<span class="rc-alt">In codice sconto <strong>' + money(v.credit) + '</strong> <em>+' + CREDIT_UP_PCT + '%</em></span>'
        : '<span class="rc-alt">Rispetto al bonifico (' + money(v.cash) + ') <em>+' + CREDIT_UP_PCT + '%</em></span>') : '';
      return '<div class="rc-pricebox"><div class="rc-price"><div class="rc-receive"><span>Ricevi' + (pay === 'cash' ? ' in bonifico' : ' in codice sconto') + '</span><strong>' + money(pay === 'cash' ? v.cash : v.credit) + '</strong></div>' +
        '<span class="rc-sell">In vendita a ' + money(v.price) + '</span></div>' + alt + '</div>';
    }
    function qtyHTML(val) { return '<div class="rc-qty"><button type="button" data-step="-1" aria-label="Una copia in meno">−</button><input type="number" min="1" value="' + val + '" data-qty aria-label="Copie"><button type="button" data-step="1" aria-label="Una copia in più">+</button></div>'; }
    function addRowHTML(inQty, v) {
      // i pezzi unici si propongono in una copia sola
      var qty = v && v.unique ? '<div class="rc-one">Pezzo unico<input type="hidden" value="1" data-qty></div>' : qtyHTML(inQty || 1);
      return '<div class="rc-add">' + qty + '<button type="button" class="rc-btn" data-add>' + (inQty ? (v && v.unique ? 'Nella proposta' : 'Aggiorna') : 'Aggiungi') + '</button></div>' +
        (inQty ? '<button type="button" class="rc-remove" data-unadd>Togli dalla proposta</button>' : '');
    }
    function imgHTML(c, v, total, eager) {
      var src = v.img;
      var attrs = src ? ' src="' + esc(sizedImg(src, 360)) + '" srcset="' + esc(sizedImg(src, 360)) + ' 360w, ' + esc(sizedImg(src, 540)) + ' 540w" sizes="(max-width: 599px) 46vw, 240px"' +
        (eager ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') + ' decoding="async" width="360" height="450"' : '';
      // versioni senza una foto loro (es. numerate o Printing Plate che non abbiamo): foto della carta, segnalata come esempio
      var plate = PLATE.test(v.title) ? v.title.replace(PLATE, '').toLowerCase() : '';
      var sample = v.sample ? '<span class="rc-sample" title="Non abbiamo una foto di questa versione: vedi la carta in un\'altra versione">' +
        (plate ? '<i class="rc-dot is-' + esc(plate) + '"></i>' : '') + 'Foto di esempio</span>' : '';
      return '<div class="rc-img' + (v.sample ? ' is-sample' : '') + '">' + (src ? '<img' + attrs + ' alt="' + esc(c.title + ', ' + v.title) + '">' : '') + sample +
        tagHTML(v) + (total ? '<span class="rc-badge">' + plural(total, 'copia', 'copie') + ' nella proposta</span>' : '') + '</div>';
    }
    function cardHTML(c, eager) {
      var v = selectedVariant(c);
      var inQty = basket[v.id] ? basket[v.id].qty : 0;
      var total = c.variants.reduce(function (s, x) { return s + (basket[x.id] ? basket[x.id].qty : 0); }, 0);
      var vs = c.variants.length > 1 ? '<div class="rc-variants' + (c.variants.length > 4 ? ' is-long' : '') + '">' + c.variants.map(function (x) {
        var q = basket[x.id] ? basket[x.id].qty : 0;
        return '<button type="button" class="rc-v' + (x.id === v.id ? ' is-active' : '') + (x.spot ? ' is-spot' : '') + (q ? ' has-qty' : '') + '" data-v="' + esc(x.id) + '"' + (q ? ' data-q="×' + q + '"' : '') + ' aria-pressed="' + (x.id === v.id) + '">' + esc(x.title) + '</button>';
      }).join('') + '</div>' : '';
      return '<article class="rc-card' + (total ? ' is-in' : '') + '" data-key="' + esc(c.key) + '">' +
        imgHTML(c, v, total, eager) +
        '<div class="rc-meta"><h3 class="rc-name">' + esc(c.title) + '</h3>' +
        (filterSet === 'all' ? '<span class="rc-set">' + esc(c.setTitle) + '</span>' : '') + '</div>' +
        vs + priceHTML(v) + addRowHTML(inQty, v) + '</article>';
    }
    function spotHTML(s, i) {
      var v = s.v, c = s.card, inQty = basket[v.id] ? basket[v.id].qty : 0;
      return '<article class="rc-card' + (inQty ? ' is-in' : '') + '" data-spot="' + esc(v.id) + '">' +
        imgHTML(c, v, inQty, i < 4) +
        '<div class="rc-meta"><h3 class="rc-name">' + esc(c.title) + '</h3>' +
        (c.variants.length > 1 ? '<span class="rc-set">' + esc(v.title) + '</span>' : '') + '</div>' +
        priceHTML(v) + addRowHTML(inQty, v) + '</article>';
    }
    function skeletonHTML(n) {
      var s = '';
      for (var i = 0; i < n; i++) s += '<div class="rc-skel" aria-hidden="true"><div class="rc-skel-img"></div><div class="rc-skel-line"></div><div class="rc-skel-line is-short"></div><div class="rc-skel-btn"></div></div>';
      return s;
    }

    function renderSpot() {
      var box = $('[data-rc-spot]');
      var list = spots.filter(function (s) {
        if (filterSet !== 'all' && s.card.setHandle !== filterSet) return false;
        if (filterVer && s.v.title !== filterVer) return false;
        return true;
      });
      box.hidden = !list.length || !!query.trim();
      $('[data-rc-spot-row]').innerHTML = list.map(spotHTML).join('');
    }
    function setReady() { return filterSet === 'all' ? allLoaded : !!loaded[filterSet]; }

    // caricamento automatico mentre si scorre (funziona con qualunque contenitore che scorre)
    var sentinel = document.createElement('div');
    sentinel.className = 'rc-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    $('.rc-more-wrap').parentNode.insertBefore(sentinel, $('.rc-more-wrap'));
    var checkQueued = false;
    function nearEnd() {
      var r = sentinel.getBoundingClientRect();
      return r.top < (window.innerHeight || document.documentElement.clientHeight || 800) + 1000;
    }
    function checkMore() {
      if (checkQueued) return;
      checkQueued = true;
      setTimeout(function () {
        checkQueued = false;
        if (!cards.length || !nearEnd()) return;
        if (appendMore()) checkMore();
      }, 60);
    }
    document.addEventListener('scroll', checkMore, { passive: true, capture: true });
    window.addEventListener('resize', checkMore, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) checkMore(); }, { rootMargin: '1000px 0px' }).observe(sentinel);
    }

    // Trascinamento col mouse delle righe che scorrono di lato (carte in evidenza, versioni di una carta, set):
    // con il dito scorrono gia' da sole, col mouse senza rotella orizzontale servirebbe la barra.
    var DRAG_SEL = '.rc-spot-row, .rc-variants, .rc-sets';
    var drag = null, eatClick = false;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var el = e.target.closest(DRAG_SEL);
      if (!el || el.scrollWidth <= el.clientWidth + 1 || e.target.closest('input, select, textarea')) return;
      drag = { el: el, x: e.clientX, left: el.scrollLeft, moved: false };
    });
    document.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        drag.moved = true;
        drag.snap = drag.el.style.scrollSnapType;
        drag.el.style.scrollSnapType = 'none';
        drag.el.classList.add('is-dragging');
      }
      drag.el.scrollLeft = drag.left - dx;
      e.preventDefault();
    });
    function endDrag() {
      if (!drag) return;
      var d = drag; drag = null;
      if (!d.moved) return;
      d.el.classList.remove('is-dragging');
      d.el.style.scrollSnapType = d.snap || '';
      eatClick = true; // il clic che chiude il trascinamento non deve scegliere una versione o aggiungere una carta
      setTimeout(function () { eatClick = false; }, 0);
    }
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
    root.addEventListener('click', function (e) { if (eatClick) { eatClick = false; e.preventDefault(); e.stopPropagation(); } }, true);
    root.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest(DRAG_SEL)) e.preventDefault(); });

    function render() {
      var grid = $('[data-rc-grid]');
      $('[data-rc-more]').hidden = true;
      renderLot();
      if (!setReady() && !filtered().length) {
        $('[data-rc-status]').textContent = 'Carico le carte…';
        grid.innerHTML = skeletonHTML(8);
        renderSpot(); renderBasket();
        return;
      }
      var list = filtered();
      $('[data-rc-status]').textContent = list.length ? plural(list.length, 'carta', 'carte') : 'Nessuna carta trovata. Prova con un altro nome o numero.';
      grid.innerHTML = list.slice(0, shown).map(function (c, i) { return cardHTML(c, i < EAGER); }).join('');
      renderSpot();
      renderBasket();
      checkMore();
    }
    function appendMore() {
      var list = filtered();
      if (list.length <= shown) return false;
      var from = shown;
      shown += PAGE;
      $('[data-rc-grid]').insertAdjacentHTML('beforeend', list.slice(from, shown).map(function (c) { return cardHTML(c, false); }).join(''));
      return true;
    }

    function findCard(key) { return cards.find(function (c) { return c.key === key; }); }
    function addToBasket(card, v, qty, additive) {
      var cur = basket[v.id];
      basket[v.id] = {
        qty: v.unique ? 1 : (additive && cur ? cur.qty + qty : qty),
        product: card.title, variant: v.title, sku: v.sku, price: v.price, cash: v.cash, credit: v.credit,
        img: v.img, set: card.setTitle, setHandle: card.setHandle, virtual: !!v.virtual, unique: !!v.unique
      };
    }
    var toastTimer;
    function toast(msg) {
      var t = $('[data-rc-toast]');
      t.textContent = msg; t.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
    }

    function selectSet(handle, silent) {
      filterSet = handle; shown = PAGE;
      root.querySelectorAll('[data-set]').forEach(function (b) { var on = b.dataset.set === handle; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
      try {
        var u = new URL(location.href);
        if (handle === DEFAULT_SET) u.searchParams.delete('set'); else u.searchParams.set('set', handle);
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
      if (silent) return;
      fillVerFilter();
      render();
    }

    // ---------- ritiro a lotto: interfaccia ----------
    // set mostrati nel pannello del lotto: quello scelto nei bottoni in alto, o tutti
    function setsDelLotto() {
      return (filterSet === 'all' ? HANDLES : [filterSet]).filter(function (h) { return cards.some(function (c) { return c.setHandle === h; }) || !loaded[h]; });
    }
    function lotRowHTML(l) {
      var q = basket[l.id] ? basket[l.id].qty : '';
      var ex = l.out.length ? '<small class="rc-lot-ex">Fuori dal lotto, da aggiungere una per una: ' + l.out.map(function (x) { return esc(shortName(x.c.title)); }).join(', ') + '</small>' : '';
      return '<div class="rc-lot-row" data-lot="' + esc(l.id) + '">' +
        '<div class="rc-lot-t"><strong>' + esc(l.title) + '</strong><small>' + l.count + ' carte, anche mescolate tra loro</small>' + ex + '</div>' +
        '<div class="rc-lot-p">' + money(pay === 'cash' ? l.cash : l.credit) + '<small>a copia</small></div>' +
        '<label class="rc-lot-q"><span class="rc-vh">Copie ' + esc(l.title) + '</span><input type="number" min="0" inputmode="numeric" placeholder="0" value="' + q + '" data-lot-qty></label>' +
        '</div>';
    }
    function renderLot() {
      var box = $('[data-rc-lot]');
      if (!box || box.hidden) return;
      var rows = $('[data-l-rows]');
      var sets = setsDelLotto();
      var html = '', any = false, waiting = false;
      sets.forEach(function (h) {
        if (!loaded[h]) { waiting = true; return; }
        var lots = lotsFor(h);
        if (!lots.length) return;
        any = true;
        if (sets.length > 1) html += '<p class="rc-lot-set-title">' + esc(TITLES[h] || h) + '</p>';
        html += lots.map(lotRowHTML).join('');
      });
      rows.innerHTML = any ? html : '<p class="rc-empty">' + (waiting ? 'Carico le carte…' : 'In questo set non ci sono versioni ritirabili a lotto.') + '</p>';
      updateLotPreview();
    }
    function lotInputs() {
      var out = [];
      root.querySelectorAll('[data-rc-lot] [data-lot]').forEach(function (row) {
        out.push({ id: row.dataset.lot, qty: Math.max(0, parseInt(row.querySelector('[data-lot-qty]').value, 10) || 0) });
      });
      return out;
    }
    function updateLotPreview() {
      var box = $('[data-l-preview]');
      if (!box) return;
      var copies = 0, tot = 0;
      lotInputs().forEach(function (x) {
        if (!x.qty) return;
        var l = findLot(x.id);
        if (!l) return;
        copies += x.qty; tot += (pay === 'cash' ? l.cash : l.credit) * x.qty;
      });
      box.textContent = copies ? plural(copies, 'copia', 'copie') + ', ricevi ' + money(tot) + (pay === 'cash' ? ' in bonifico' : ' in codice sconto') : 'Scrivi quante copie hai per ogni versione.';
    }
    function addLots() {
      var added = 0, changed = false;
      lotInputs().forEach(function (x) {
        var l = findLot(x.id);
        if (!l) return;
        if (!x.qty) { if (basket[x.id]) { delete basket[x.id]; changed = true; } return; }
        basket[x.id] = {
          qty: x.qty, lot: true, product: 'Lotto ' + l.title + ' (carte non divise)', variant: l.title, sku: l.sku,
          price: l.price, cash: l.cash, credit: l.credit, img: '', set: l.setTitle, setHandle: l.set, virtual: false
        };
        added += x.qty; changed = true;
      });
      if (!changed) { toast('Scrivi almeno una quantità.'); return; }
      save(); render(); renderBasket(true);
      toast(added ? plural(added, 'copia', 'copie') + ' a lotto nella proposta' : 'Lotto aggiornato');
    }
    function togglePanel(name) {
      [['lot', '[data-rc-lot]', '[data-rc-lot-toggle]']].forEach(function (p) {
        var box = $(p[1]), btn = $(p[2]);
        if (!box || !btn) return;
        var open = p[0] === name ? box.hidden : false;
        box.hidden = !open; btn.setAttribute('aria-expanded', open); btn.classList.toggle('rc-btn--outline', !open);
      });
      renderLot();
      var box = $('[data-rc-lot]');
      if (name === 'lot' && box && !box.hidden && box.scrollIntoView) {
        try { box.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
      }
    }

    // ---------- eventi ----------
    root.addEventListener('click', function (e) {
      var t = e.target;
      var setChip = t.closest('[data-set]');
      if (setChip) { selectSet(setChip.dataset.set); return; }
      var payBtn = t.closest('[data-pay]');
      if (payBtn) {
        setPay(payBtn.dataset.pay);
        payout = pay;
        var rb = root.querySelector('[data-rc-payout][value="' + pay + '"]');
        if (rb) rb.checked = true;
        render(); return;
      }
      var pctBtn = t.closest('[data-rc-pct]');
      if (pctBtn) {
        var tt = totals();
        $('[data-rc-mix-amount]').value = floor2(tt.cash * parseInt(pctBtn.dataset.rcPct, 10) / 100).toFixed(2);
        renderBasket(); return;
      }
      if (t.closest('[data-rc-lot-toggle]')) { togglePanel('lot'); return; }
      if (t.closest('[data-rc-lot-close]')) { togglePanel('none'); return; }
      if (t.closest('[data-l-add]')) { addLots(); return; }
      if (t.closest('[data-rc-more]')) { appendMore(); return; }

      var spotEl = t.closest('[data-spot]');
      if (spotEl) {
        var hit = byVariant[spotEl.dataset.spot];
        if (!hit) return;
        var sstep = t.closest('[data-step]');
        if (sstep) { var si = spotEl.querySelector('[data-qty]'); si.value = Math.max(1, (parseInt(si.value, 10) || 1) + parseInt(sstep.dataset.step, 10)); return; }
        if (t.closest('[data-unadd]')) { delete basket[hit.v.id]; save(); refreshCard(hit.card); renderSpot(); renderBasket(); toast('Carta tolta dalla proposta'); return; }
        if (t.closest('[data-add]')) {
          addToBasket(hit.card, hit.v, Math.max(1, parseInt(spotEl.querySelector('[data-qty]').value, 10) || 1), false);
          save(); refreshCard(hit.card); renderSpot(); renderBasket(true);
        }
        return;
      }

      var cardEl = t.closest('.rc-card[data-key]');
      if (cardEl) {
        var c = findCard(cardEl.dataset.key);
        if (!c) return;
        var vb = t.closest('.rc-v[data-v]');
        if (vb) {
          var sc = cardEl.querySelector('.rc-variants') ? cardEl.querySelector('.rc-variants').scrollLeft : 0;
          c._sel = vb.dataset.v;
          var fresh = refreshCard(c);
          if (fresh && fresh.querySelector('.rc-variants')) fresh.querySelector('.rc-variants').scrollLeft = sc;
          return;
        }
        var step = t.closest('[data-step]');
        if (step) {
          var inp = cardEl.querySelector('[data-qty]');
          inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(step.dataset.step, 10));
          return;
        }
        var cv = selectedVariant(c);
        if (t.closest('[data-unadd]')) {
          delete basket[cv.id]; save(); refreshCard(c);
          if (cv.spot) renderSpot();
          renderBasket(); toast('Carta tolta dalla proposta');
          return;
        }
        if (t.closest('[data-add]')) {
          addToBasket(c, cv, Math.max(1, parseInt(cardEl.querySelector('[data-qty]').value, 10) || 1), false);
          save(); refreshCard(c);
          if (cv.spot) renderSpot();
          renderBasket(true);
          return;
        }
      }

      if (t.closest('[data-rc-open]')) { openDrawer(true); return; }
      if (t.closest('[data-rc-close]')) { openDrawer(false); return; }
      if (t.closest('[data-rc-clear]')) {
        if (confirm('Vuoi togliere tutte le carte dalla proposta?')) { basket = {}; save(); render(); }
        return;
      }
      var line = t.closest('[data-line]');
      if (line) {
        var id = line.dataset.line;
        if (t.closest('[data-remove]')) { delete basket[id]; save(); render(); return; }
        var ls = t.closest('[data-lstep]');
        if (ls && basket[id]) { basket[id].qty = Math.max(1, basket[id].qty + parseInt(ls.dataset.lstep, 10)); if (basket[id].unique) basket[id].qty = 1; save(); render(); }
      }
    });

    function setPay(p) {
      pay = p;
      root.querySelectorAll('[data-pay]').forEach(function (b) { var on = b.dataset.pay === p; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
    }
    // aggiorna solo la carta interessata nella griglia (senza ridisegnare tutto)
    function refreshCard(c) {
      var el = root.querySelector('[data-rc-grid] .rc-card[data-key="' + c.key.replace(/"/g, '\\"') + '"]');
      if (!el) return null;
      var tmp = document.createElement('div');
      tmp.innerHTML = cardHTML(c, false);
      var fresh = tmp.firstChild;
      el.replaceWith(fresh);
      return fresh;
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-lqty]')) {
        var id = t.closest('[data-line]').dataset.line;
        var q = parseInt(t.value, 10) || 0;
        if (q <= 0) delete basket[id]; else basket[id].qty = basket[id].unique ? 1 : q;
        save(); render(); return;
      }
      if (t.matches('[data-rc-payout]')) {
        payout = t.value;
        if (payout !== 'mix') { setPay(payout); render(); } else renderBasket();
        return;
      }
      if (t.matches('[data-rc-cashmethod]')) { renderBasket(); return; }
      if (t.matches('[data-rc-verfilter]')) { filterVer = t.value; shown = PAGE; cards.forEach(function (c) { delete c._sel; }); render(); return; }
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-lot-qty]')) updateLotPreview();
      if (e.target.matches('[data-rc-mix-amount]')) renderBasket();
      if (e.target.matches('[data-rc-iban]')) e.target.setCustomValidity(!e.target.value || ibanOk(e.target.value) ? '' : 'Controlla l\'IBAN: sembra sbagliato.');
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !$('[data-rc-drawer]').hidden) openDrawer(false);
      if (e.key === 'Enter' && e.target.matches('[data-lot-qty]')) { e.preventDefault(); addLots(); }
    });
    var searchTimer;
    $('[data-rc-search]').addEventListener('input', function (e) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { query = e.target.value; shown = PAGE; render(); }, 180);
    });

    // ---------- proposta ----------
    function totals() {
      var credit = 0, cash = 0, count = 0, lotCount = 0;
      Object.keys(basket).forEach(function (id) {
        var b = basket[id];
        credit += b.credit * b.qty;
        cash += b.cash * b.qty;
        count += b.qty;
        if (b.lot) lotCount += b.qty;
      });
      credit = Math.round(credit * 100) / 100; cash = Math.round(cash * 100) / 100;
      return { credit: credit, cash: cash, count: count, lotCount: lotCount, chosen: pay === 'cash' ? cash : credit };
    }
    // Pagamento scelto: tutto in bonifico/PayPal, tutto in credito, oppure una parte in bonifico e il resto in credito (+CREDIT_UP).
    function payoutOf(tot) {
      if (payout === 'credit') return { cash: 0, credit: tot.credit, total: tot.credit };
      if (payout === 'mix') {
        var inp = $('[data-rc-mix-amount]');
        var x = floor2(Math.min(Math.max(parseFloat(String((inp && inp.value) || '').replace(',', '.')) || 0, 0), tot.cash));
        var cr = floor2((tot.cash - x) * (1 + CREDIT_UP));
        return { cash: x, credit: cr, total: Math.round((x + cr) * 100) / 100 };
      }
      return { cash: tot.cash, credit: 0, total: tot.cash };
    }
    function ibanOk(v) {
      v = String(v || '').replace(/\s+/g, '').toUpperCase();
      if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(v)) return false;
      var r = v.slice(4) + v.slice(0, 4), m = 0;
      for (var i = 0; i < r.length; i++) {
        var c = r.charCodeAt(i), d = c >= 65 ? String(c - 55) : r.charAt(i);
        for (var j = 0; j < d.length; j++) m = (m * 10 + (d.charCodeAt(j) - 48)) % 97;
      }
      return m === 1;
    }
    function isPaypal() { var s = $('[data-rc-cashmethod]'); return !!s && s.value === 'paypal'; }
    function updatePayoutUI(tot, pt) {
      if (!$('[data-rc-cashbox]')) return;
      $('[data-rc-o-cash]').textContent = money(tot.cash);
      $('[data-rc-o-credit]').textContent = money(tot.credit);
      $('[data-rc-mix]').hidden = payout !== 'mix';
      $('[data-rc-mix-amount]').max = tot.cash.toFixed(2);
      root.querySelectorAll('[data-rc-pct]').forEach(function (b) {
        var on = payout === 'mix' && tot.cash > 0 && Math.abs(pt.cash - floor2(tot.cash * parseInt(b.dataset.rcPct, 10) / 100)) < 0.005;
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
      });
      $('[data-rc-mix-text]').textContent = payout === 'mix' ? 'Ricevi ' + money(pt.cash) + (isPaypal() ? ' con PayPal' : ' in bonifico') + ' e ' + money(pt.credit) + ' in codice sconto.' : '';
      // IBAN o email PayPal obbligatori quando una parte si paga in denaro
      var needCash = payout === 'cash' || (payout === 'mix' && pt.cash > 0);
      var pp = isPaypal(), iban = $('[data-rc-iban]'), mail = $('[data-rc-ppmail]');
      $('[data-rc-cashbox]').hidden = !needCash;
      $('[data-rc-iban-wrap]').hidden = pp; $('[data-rc-pp-wrap]').hidden = !pp;
      iban.disabled = !needCash || pp; iban.required = !iban.disabled;
      mail.disabled = !needCash || !pp; mail.required = !mail.disabled;
    }
    function orderedIds() {
      return Object.keys(basket).sort(function (a, b) {
        var A = basket[a], B = basket[b];
        return (setIndex(A.setHandle) - setIndex(B.setHandle)) || ((A.lot ? 1 : 0) - (B.lot ? 1 : 0)) || String(A.variant).localeCompare(String(B.variant)) || cmpKey(sortKey(A.product), sortKey(B.product));
      });
    }
    function renderBasket(pulse) {
      var ids = orderedIds();
      var tot = totals();
      var pt = payoutOf(tot);
      var missing = Math.max(0, Math.round((MIN_TOTAL - pt.total) * 100) / 100);
      var bar = $('[data-rc-bar]');
      bar.hidden = ids.length === 0;
      $('[data-rc-bar-count]').textContent = plural(tot.count, 'carta', 'carte') + ', ' + (payout === 'mix' ? 'in parte in codice sconto' : payout === 'cash' ? 'bonifico' : 'codice sconto');
      $('[data-rc-bar-total]').textContent = money(pt.total);
      var bm = $('[data-rc-bar-min]');
      bm.hidden = missing <= 0;
      bm.textContent = 'Mancano ' + money(missing) + ' al minimo di ' + money(MIN_TOTAL);
      var up = $('[data-rc-bar-up]');
      if (up) {
        up.hidden = !(payout === 'cash' && CREDIT_UP > 0 && missing <= 0);
        up.textContent = 'In codice sconto: ' + money(tot.credit);
      }
      $('[data-rc-bar-progress]').style.width = (MIN_TOTAL > 0 ? Math.min(100, pt.total / MIN_TOTAL * 100) : 100) + '%';
      $('[data-rc-bar-progress]').hidden = missing <= 0;
      if (pulse && bar.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) bar.animate([{ transform: 'translateX(-50%) scale(1)' }, { transform: 'translateX(-50%) scale(1.03)' }, { transform: 'translateX(-50%) scale(1)' }], { duration: 250 });

      var lastGroup = '';
      $('[data-rc-lines]').innerHTML = ids.length ? ids.map(function (id) {
        var b = basket[id];
        var group = b.lot ? b.set + ': a lotto' : b.set + ': ' + b.variant;
        var head = group !== lastGroup ? '<div class="rc-group">' + esc(group) + '</div>' : '';
        lastGroup = group;
        return head + '<div class="rc-line' + (b.lot ? ' is-lot' : '') + '" data-line="' + esc(id) + '">' +
          (b.img ? '<img src="' + esc(sizedImg(b.img, 120)) + '" alt="" loading="lazy">' : '<span class="rc-line-ico" aria-hidden="true">' + (b.lot ? '▤' : '') + '</span>') +
          '<div class="rc-line-t">' + esc(b.product) + '<small>' + esc(b.variant) + ', ' + money(unitOf(b)) + ' a copia</small></div>' +
          '<div class="rc-line-r">' +
            (b.unique ? '<span class="rc-one">Pezzo unico</span>' : '<div class="rc-qty"><button type="button" data-lstep="-1" aria-label="Una copia in meno">−</button><input type="number" min="0" value="' + b.qty + '" data-lqty aria-label="Copie"><button type="button" data-lstep="1" aria-label="Una copia in più">+</button></div>') +
            '<strong>' + money(unitOf(b) * b.qty) + '</strong>' +
            '<button type="button" class="rc-remove" data-remove>Rimuovi</button>' +
          '</div></div>';
      }).join('') : '<p class="rc-empty">La proposta è vuota. Aggiungi le carte che vuoi venderci dalla pagina.</p>';
      $('[data-rc-clear]').hidden = ids.length === 0;
      $('[data-rc-sum-credit]').textContent = money(tot.credit);
      $('[data-rc-sum-cash]').textContent = money(tot.cash);
      root.querySelectorAll('[data-sum]').forEach(function (r) { r.classList.toggle('is-chosen', r.dataset.sum === payout); });
      var mixRow = root.querySelector('[data-sum="mix"]');
      if (mixRow) { mixRow.hidden = payout !== 'mix'; $('[data-rc-sum-mix]').textContent = money(pt.cash) + ' + ' + money(pt.credit) + ' sconto'; }
      var minBox = $('[data-rc-min]');
      minBox.hidden = !ids.length || missing <= 0;
      minBox.textContent = 'Il minimo per una proposta è ' + money(MIN_TOTAL) + (payout === 'mix' ? ' in tutto' : ' in ' + (payout === 'cash' ? 'bonifico' : 'codice sconto')) + '. Aggiungi carte per altri ' + money(missing) + '.';
      updatePayoutUI(tot, pt);
      var sub = form.querySelector('[data-rc-submit]');
      if (!sub.dataset.sending) sub.disabled = !ids.length || missing > 0;
    }
    function openDrawer(open) {
      $('[data-rc-drawer]').hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var x = $('.rc-x'); if (x) x.focus(); }
    }
    function proposalCode() {
      var d = new Date();
      var p = function (n) { return String(n).padStart(2, '0'); };
      return 'RIT-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
    }
    // Prima di ogni invio: listino del PDC e prezzi delle carte riletti dal negozio, proposta ricalcolata.
    // Se un prezzo e' cambiato l'invio si ferma e il cliente vede cosa e' cambiato; al secondo clic parte con i prezzi nuovi.
    var verified = false;
    function freshConfig() {
      var sid = String(root.id || '').replace(/^rc-/, '');
      if (!sid) return Promise.resolve(null);
      return fetch(location.pathname + '?section_id=' + encodeURIComponent(sid) + '&_rc=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var el = html && new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-rc-config]');
          return el ? JSON.parse(el.textContent).prices || null : null;
        }).catch(function () { return null; });
    }
    function verifyPrices() {
      var handles = {};
      Object.keys(basket).forEach(function (id) {
        var b = basket[id], m = String(id).match(/^lotto:([^:]+):/);
        var h = m ? m[1] : b.setHandle;
        if (h) handles[h] = true;
      });
      priceChanges = {};
      var list = Object.keys(handles);
      return Promise.all([freshConfig()].concat(list.map(function (h) { return fetchRaw(h, true).catch(function () { return null; }); })))
        .then(function (res) {
          if (res[0]) applyPrices(res[0]);
          list.forEach(function (h, i) { if (res[i + 1] && res[i + 1].length) { raw[h] = res[i + 1]; loaded[h] = true; } });
          rebuild();
          return Object.keys(priceChanges).length > 0;
        }).catch(function () { return false; });
    }
    form.addEventListener('submit', function (e) {
      var vbtn = form.querySelector('[data-rc-submit]');
      if (!verified) {
        e.preventDefault();
        if (vbtn.dataset.checking) return;
        vbtn.dataset.checking = '1';
        vbtn.disabled = true;
        var label = vbtn.textContent;
        vbtn.textContent = 'Controllo i prezzi aggiornati…';
        verifyPrices().then(function (changed) {
          delete vbtn.dataset.checking;
          vbtn.textContent = label;
          renderBasket();
          if (changed) { showChanges(); changesBox().scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
          verified = true;
          vbtn.disabled = false;
          vbtn.click();
        });
        return;
      }
      verified = false;
      clearChanges();
      var ids = orderedIds();
      var tot = totals();
      var pt = payoutOf(tot);
      if (!ids.length || pt.total < MIN_TOTAL) { e.preventDefault(); renderBasket(); return; }
      var ib = $('[data-rc-iban]');
      if (ib && !ib.disabled && !ibanOk(ib.value)) {
        e.preventDefault(); ib.setCustomValidity('Controlla l\'IBAN: sembra sbagliato.'); ib.reportValidity(); return;
      }
      var code = proposalCode();
      var pp = isPaypal();
      // "Misto" il PDC non lo riconosce ancora: la proposta resta da controllare a mano invece di essere letta male.
      var kind = payout === 'mix' ? (pt.credit <= 0 ? 'cash' : pt.cash <= 0 ? 'credit' : 'mix') : payout;
      var payLabel = kind === 'credit' ? 'Codice sconto (credito)' : kind === 'mix' ? 'Misto' : (pp ? 'PayPal (come bonifico)' : 'Bonifico');
      var unitPaid = function (b) { return kind === 'credit' ? b.credit : b.cash; };
      var clean = function (s) { return String(s).replace(/;/g, ',').replace(/\n/g, ' '); };
      var lines = ids.map(function (id) {
        var b = basket[id];
        return '- ' + b.qty + ' x ' + b.product + ' [' + b.variant + '] (' + b.sku + ')' + (b.virtual ? ' *variante da creare*' : '') + (b.lot ? ' *da smistare*' : '') + ' = ' + money(unitPaid(b) * b.qty);
      });
      var csv = ['variant_id;sku;set;prodotto;variante;quantita;prezzo_vendita;prezzo_credito;prezzo_bonifico;nuova_variante'].concat(ids.map(function (id) {
        var b = basket[id];
        return [(b.virtual || b.lot) ? '' : id, b.sku, clean(b.set), clean(b.product), clean(b.variant), b.qty, b.price.toFixed(2), b.credit.toFixed(2), b.cash.toFixed(2), b.lot ? 'lotto' : (b.virtual ? 'si' : 'no')].join(';');
      }));
      form.querySelector('[data-rc-f-code]').value = code;
      form.querySelector('[data-rc-f-pay]').value = payLabel;
      form.querySelector('[data-rc-f-total]').value = money(kind === 'mix' ? pt.total : kind === 'credit' ? tot.credit : tot.cash);
      var fc = form.querySelector('[data-rc-f-cashpart]'), fr = form.querySelector('[data-rc-f-creditpart]');
      if (fc) fc.value = money(kind === 'credit' ? 0 : kind === 'mix' ? pt.cash : tot.cash) + (kind === 'credit' ? '' : pp ? ' con PayPal' : ' in bonifico');
      if (fr) fr.value = money(kind === 'credit' ? tot.credit : kind === 'mix' ? pt.credit : 0);
      form.querySelector('[data-rc-f-count]').value = tot.count;
      form.querySelector('[data-rc-f-body]').value = [
        'PROPOSTA DI VENDITA ' + code,
        'Metodo scelto: ' + payLabel + ' - Totale: ' + money(kind === 'mix' ? pt.total : kind === 'credit' ? tot.credit : tot.cash),
        kind === 'mix' ? 'Ripartizione: ' + money(pt.cash) + (pp ? ' con PayPal' : ' in bonifico') + ' + ' + money(pt.credit) + ' in codice sconto (carte per ' + money(tot.cash - pt.cash) + ' di bonifico convertite con il +' + CREDIT_UP_PCT + '%)' : (kind === 'cash' ? 'Ricevi con: ' + (pp ? 'PayPal' : 'bonifico') : ''),
        '(Bonifico: ' + money(tot.cash) + ' | Codice sconto: ' + money(tot.credit) + ')',
        'Carte: ' + tot.count + (tot.lotCount ? ' (di cui ' + tot.lotCount + ' a lotto, da smistare)' : ''),
        '',
        lines.join('\n'),
        '',
        '---CSV RITIRO---',
        csv.join('\n'),
        '---FINE CSV---'
      ].join('\n');
      var btn = form.querySelector('[data-rc-submit]');
      btn.dataset.sending = '1';
      btn.disabled = true;
      btn.textContent = 'Invio in corso…';
    });

    if (root.querySelector('[data-rc-posted]')) { basket = {}; save(); openDrawer(true); }
    else if (root.querySelector('.rc-err')) { openDrawer(true); }
    selectSet(filterSet, true);
    render();
    start();
  }

  // Parte subito (lo script e' dopo la sezione), senza aspettare le app del tema.
  function boot() { document.querySelectorAll('[data-rc-root]').forEach(init); }
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
